<div class="flex-left-column light-control-host sandbox-events-host">
  <div class="modal-header">
    <h3 class="panel-title">Network Sandbox Event Log</h3>
    <button
      type="button"
      class="modal-close-btn"
      (click)="close.emit()"
      pTooltip="Close"
      tooltipPosition="left"
      aria-label="Close"
    >
      <i class="fa-utility fa-semibold fa-xmark"></i>
    </button>
  </div>

  <p-table
    #dt
    [value]="awsEventLogs"
    [globalFilterFields]="['srcIp', 'srcPort', 'destIp', 'destPort', 'proto', 'action', 'sni']"
    dataKey="flowId"
    [tableStyle]="{ 'min-width': '40rem' }"
    [styleClass]="'p-datatable-sm aws-fwlogs-datatable'"
    [rowHover]="true"
    selectionMode="none"
  >
    <ng-template pTemplate="caption">
      <div class="caption-container">
        <p-iconfield class="filter-container">
          <input pInputText #filterInput type="text" (keydown)="onKeyDown($event)" placeholder="Filter events..." />
          @if (!isFilterApplied && !loading) {
            <p-inputicon class="fa-utility-fill fa-semibold fa-filter fade-icon" />
          }
          @if (isFilterApplied && !loading) {
            <p-inputicon (click)="clearFilter()" class="fa-utility fa-semibold fa-xmark" />
          }
          @if (loading) {
            <p-inputicon class="fa-solid fa-spinner fa-spin" />
          }
        </p-iconfield>

        <select class="arpio-select" [(ngModel)]="timeSelected" (change)="fetchLogs()">
          @for (option of timeOptions; track option) {
            <option [ngValue]="option">{{ option.label }}</option>
          }
        </select>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="timestamp" class="strong-text whitespace-nowrap">
          Timestamp <p-sortIcon field="timestamp"></p-sortIcon>
        </th>
        <th pSortableColumn="srcIp" class="strong-text whitespace-nowrap">
          Source IP <p-sortIcon field="srcIp"></p-sortIcon>
        </th>
        <th pSortableColumn="srcPort" class="strong-text whitespace-nowrap">
          Source Port <p-sortIcon field="srcPort"></p-sortIcon>
        </th>
        <th pSortableColumn="destIp" class="strong-text whitespace-nowrap">
          Destination IP <p-sortIcon field="destIp"></p-sortIcon>
        </th>
        <th pSortableColumn="destPort" class="strong-text whitespace-nowrap">
          Destination Port <p-sortIcon field="destPort"></p-sortIcon>
        </th>
        <th pSortableColumn="proto" class="strong-text whitespace-nowrap">
          Protocol <p-sortIcon field="proto"></p-sortIcon>
        </th>
        <th pSortableColumn="action" class="strong-text whitespace-nowrap">
          Action <p-sortIcon field="action"></p-sortIcon>
        </th>
        <th pSortableColumn="sni" class="strong-text whitespace-nowrap">SNI <p-sortIcon field="sni"></p-sortIcon></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-log>
      <tr>
        <td>{{ log.timestamp.toISOString() }}</td>
        <td>{{ log.srcIp }}</td>
        <td>{{ log.srcPort }}</td>
        <td>{{ log.destIp }}</td>
        <td>{{ log.destPort }}</td>
        <td>{{ log.proto }}</td>
        <td>{{ log.action }}</td>
        <td>{{ log.sni }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="text-center default-padding loading-text">
          @if (loading) {
            <i class="fa-solid fa-spinner fa-spin"></i> Loading events...
          }
          @if (!loading) {
            No events found.
          }
        </td>
      </tr>
    </ng-template>

    <!-- Table Summary -->
    <ng-template pTemplate="summary">
      <div class="flex gap-2 align-items-center justify-content-between">
        @if (loading) {
          <div>Loading ...</div>
        }
        @if (errorMessage && !loading) {
          {{ errorMessage }} <a (click)="fetchLogs()">Click here to refresh</a>
        }
      </div>
    </ng-template>
  </p-table>

  @if (awsConsoleUrl) {
    <div class="modal-footer">
      <a [href]="awsConsoleUrl" target="_blank">View events in CloudWatch</a>
    </div>
  }
</div>
